export default __webpack_public_path__ + "static/media/suspension_icon.1c95c64a.svg";